import { render, staticRenderFns } from "./MhaComp.vue?vue&type=template&id=42d121fd&scoped=true"
import script from "./MhaComp.vue?vue&type=script&lang=js"
export * from "./MhaComp.vue?vue&type=script&lang=js"
import style0 from "./MhaComp.vue?vue&type=style&index=0&id=42d121fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d121fd",
  null
  
)

export default component.exports